import useResources from "./use-resources";
import type { DocumentFile } from "../models/document";

export type DiagnosticFilesById = Record<number, DocumentFile[] | undefined>;

function useDiagnosticFiles(path: string) {
  const { resources, error, isLoading, mutate } = useResources(path);
  return {
    filesById: resources as unknown as DiagnosticFilesById,
    error,
    isLoading,
    mutate,
  };
}

/** Diagnostics des biens du compte, indexés par id de bien. */
export default function usePropertyDiagnostics() {
  const { filesById, ...rest } = useDiagnosticFiles(
    "/documents/property-diagnostics",
  );
  return { diagnosticsByProperty: filesById, ...rest };
}

/** Diagnostics déposés sur les dossiers (immeubles) du compte, indexés par id de dossier. */
export function usePropertyFolderDiagnostics() {
  const { filesById, ...rest } = useDiagnosticFiles(
    "/documents/property-folder-diagnostics",
  );
  return { diagnosticsByFolder: filesById, ...rest };
}
